import { Box, CircularProgress } from '@mui/material';

export const LoadingFullScreen = ({ open }: { open: boolean }) => {
  return open ? (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 1300,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress size={40} thickness={4} />
    </Box>
  ) : null;
};

export default LoadingFullScreen;
